/* global GIF */
import React, { Component, Fragment } from 'react';
import { Link, NavLink } from "react-router-dom";
import GlobalNav from '../GlobalNav/GlobalNav';
import async from 'async';
import './GifMaker.scss';

// HELPERS
import { detectMobile } from '../../_helpers';

const RANDOS = [
    'I sweetened the deal with this GIF',
    "Let's GIF ourselves a closed deal!!",
    "Here's some flavour for your emails",
    'A custom GIF to spice up Slack',
    'I got this GIF for you!',
    'You deserve a great GIF',
    'My face is in your space, yo!',
    'The GIF of winning',
    "ABG ... Always Be GIF'in",
    'Hot damn, this is the perfect GIF!',
    "Level up your GIF'in game",
    "<insert name>, I was thinkin' 'bout you!"
]

class GifMaker extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            text : RANDOS[Math.floor(Math.random()*RANDOS.length)],
            startButton : 'Start',
            video : false, // if not using a webcam stream... set to a URL,
            length : 5,
            delay : 150, // sample rate/pace
            width : 522,
            height : 294,
            progress : 0,
            camera : false, // is camera on?
            facingMode: 'user', // user, environment
            aspectRatio : 1.333, // cam aspect ratio
            isMobile : false,
            render : false, // camera is stoped, GIF being created
            recording : false, // camera is on, frames being created
            done : false, // the whole process has completed
            error : false
        }    
    }
    componentDidMount () {
        // ready
        let logo = new Image();
        logo.src = '/assets/img/logo-klue.svg';
        
        this.setDevice();
        
        this.setState({
            logo : logo
        })
    }
    setDevice = () => {
        // ghetto check mobile device(s)
        // if the screen is < 800px... 
        let _chkWidth = window.innerWidth,
            _width = _chkWidth < 800 ? _chkWidth : this.state.width;
            
        this.setState({
            width : _width,
            isMobile : detectMobile() // be sure
        })
    }   
    generateThumbnail = (video) => {     
        //generate thumbnail URL data
        const _canvas = document.createElement('canvas');
            _canvas.width = this.state.width;
            _canvas.height = this.state.height;
        
        const _context = _canvas.getContext('2d');
            _context.drawImage(video, 0, 0, this.state.width, this.state.height);
            
            _context.drawImage(this.state.logo, 15, 15, 36, 15);
/*
            logo.onload = function(){
                _context.drawImage(logo, this.state.width - 48, this.state.height - 22, 44, 18);
            }.bind(this)
*/
            
            _context.font = `bold 24px sans-serif`;
            _context.textAlign = 'center';
            _context.textBaseline = 'middle';
            _context.lineWidth = 3;
            _context.strokeStyle = '#FC585F';
            _context.strokeText(this.state.text, this.state.width/2, this.state.height-40);
            
            _context.fillStyle = '#FC585F';
            _context.fillText(this.state.text, (this.state.width/2)+4, this.state.height-43);
            
            _context.fillStyle = '#fff69d';
            _context.fillText(this.state.text, this.state.width/2, this.state.height-40);

        const _dataURL = _canvas.toDataURL();
    
        //create img
        const img = document.createElement('img');
        img.setAttribute('src', _dataURL);
        img.setAttribute('class', 'GifMaker--source');
    
        //append img in container div
        document.getElementsByClassName('GifMaker--thumbnails')[0].appendChild(img);
    }
    handleGIFVideo = () => {
        let _imgRender = document.querySelectorAll('.GifMaker--render')[0],
            _video = document.querySelectorAll('.GifMaker--video--source')[0],
            _timer = null,
            _startTime = null,
            _sampleInterval = this.state.delay; //ms

        const capture = () => {
            let _secondsPast = Math.floor((Date.now() - _startTime)/1000);
            
            this.setState({
                progress : Math.floor((_secondsPast / this.state.length) * 100) + "%"
            })
            
            if (_secondsPast > this.state.length) {
                return stopRecording();
            } else {
                return this.generateThumbnail(_video);
            }
        }
        
        _video.addEventListener('play', function() {
            _startTime = Date.now();
            return _timer = setInterval(capture, _sampleInterval);
        });

        _video.addEventListener('ended', function() { // ended
            // if we reached the end of the stream/video
            return stopRecording();
        });
        
        let stopRecording = () => {
            console.log("finish");
            if (!window.StyleMedia) {
                // not MS Edge
                this.handleCamStop();
            }
            clearInterval(_timer);
            _video.pause();
            
            this.handleGIFImage();
            this.setState({
                render : true,
                camera : false
            });
        }
        
        let startRecording = () => {
            console.log("begin");
            // make sure no thumbs exist if they did this before
            document.getElementsByClassName('GifMaker--thumbnails')[0].innerHTML = "";
            _imgRender.removeAttribute('src');
            _video.pause();
            if (!window.StyleMedia) {
                // not MS Edge
                _video.currentTime = 0;
            }
            _video.play();
            this.setState({
                recording : true
            })
        }
        
        // we're going live, ppl
        startRecording();
        
    }
    handleGIFImage = () => {        
        let _imgRender = document.querySelectorAll('.GifMaker--render')[0];

        var gif = new GIF({
            workerScript : '/assets/js/gif.worker.js',
            workers: 3,
            quality: 4,
            //dither: 'FloydSteinberg',
            width: this.state.width,
            height: this.state.height
        });
        
        const loadImage = function(src, callback) {
            const img = new Image();
            img.onload = () => callback(null, img);
            img.onerror = () => callback(new Error(`Could load ${ src }`));
            return img.src = src;
        };
        
        let _images = Object.values(document.querySelectorAll('.GifMaker--source')).map(image => image.src),
            _delay = this.state.delay;
     
        async.map(_images, loadImage, function(error, images) {
            if (error !== null) { 
                throw error; 
            }
            for (let image of Array.from(images)) { 
                gif.addFrame(image, {delay: _delay, copy: true}); 
            }
            return gif.render();
        });
        
        gif.on('finished', function(blob) {
            _imgRender.src = URL.createObjectURL(blob);
            document.getElementsByClassName('GifMaker--thumbnails')[0].innerHTML = ""; // remove the thumbs
            this.setState({
                done : true // completed the whole shabang-bang
            })
        }.bind(this));
    }
    handleCameraToggle = () => {
        if (navigator.mediaDevices.getUserMedia) {
            this.setState({
                facingMode : this.state.facingMode !== 'user' ? 'user' : 'environment'
            })
        }
    }
    handleCamStart = () => {
        const _video = document.querySelector(".GifMaker--video--source");
            
        if (navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: { facingMode : this.state.facingMode }})
            .then(function (stream) {
                _video.srcObject = stream;
                //console.log(window.screen.orientation);
                //window.screen.orientation.lock("portrait-secondary");
                
                let _orientation = window.screen.msOrientation || window.screen.mozOrientation || (window.screen.orientation || {}).type,
                    _aspectRatio = stream.getVideoTracks()[0].getSettings().aspectRatio;
                
                _aspectRatio = (_aspectRatio === undefined) ? this.state.aspectRatio : _aspectRatio; // fallback
                
                let _height = _orientation !== 'landscape-primary' ?  Math.floor(this.state.width * _aspectRatio) : Math.floor(this.state.width / _aspectRatio);
                
/*
                var orientation = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type;
                if (window.screen.orientation.type) {
                    _orientation = window.screen.orientation.type;
                }
*/
                
                this.setState({
                    camera : true,
                    aspectRatio : _aspectRatio,
                    orientation : _orientation,
                    width : this.state.width,
                    height : _height != NaN ? _height : 294
                })
            }.bind(this))
            .catch(function (err0r) {
                console.log(err0r);
            });
        }
    }
    handleCamStop = (e) => {
        let _video = document.querySelector(".GifMaker--video--source"),
            _stream = _video.srcObject,
            _tracks = _stream.getTracks();

          for (var i = 0; i < _tracks.length; i++) {
            var _track = _tracks[i];
            _track.stop();
        }
        _video.srcObject = null;
    }
    handleKeyPress = (e) => {
        var keyCode = e.keyCode || e.which;
        if (keyCode == '13'){
            // Enter pressed
            this.handleClickStart();
        }
    }
    handleText = (e) => {
        this.setState({
            text : e.target.value
        })
    }
    handleClickStart = () => {
        this.handleCamStart();
        
        // countdown
        let i = 1;
        let _countdown = setInterval(function(){
            if (this.state.camera) {
                // once the camera is allowed by browser/user...
                if (i >= 5) {
                     clearInterval(_countdown);
                     this.handleGIFVideo();
                } else {
                    this.setState({
                        startButton : 5 - i
                    })
                }
                
                i++;
            }
        }.bind(this), 1000);
    }
    handleClickFocus = (e) => {
        window.scrollTo(0, e.offsetTop)
    }
    handleRedo = () => {
        this.setState({
            startButton : 'Start',
            width : 522,
            height : 294,
            progress : 0,
            render : false,
            recording : false,
            done : false,
            error : false
        })
        this.setDevice();
    }
    render () {
        return (
            <main class="GifMaker">
                { (!this.state.camera && (!this.state.render || this.state.done)) && <GlobalNav /> }
                <section>
                    <div class={ this.state.render ? "GifMaker--wrapper on" : "GifMaker--wrapper off" }
                        style={{
                            width: this.state.width,
                            height: this.state.height
                        }}
                    >
                        <div>
                            <img class="GifMaker--render" />
                        </div>
                    </div>
                    { (!this.state.render) &&
                        <div  class={ !this.state.render ? "GifMaker--video on" : "GifMaker--video off" }
                            style={{
                                width: this.state.width,
                                height: this.state.height
                            }}
                        >
                            { !this.state.recording && 
                                <button 
                                    onClick={ this.handleClickStart }
                                    disabled={ this.state.startButton !== 'Start' }
                                    class="GifMaker--start">{ this.state.startButton }</button> 
                            }
                            <video class={ this.state.facingMode !== 'user' ? 'GifMaker--video--source' : 'GifMaker--video--source mirror' } 
                                width="522" height="323">
                                { this.state.video && <source src={ this.state.video } type="video/mp4"  /> }
                            </video>                    
                        </div>
                    }
                    
                    <div class="GifMaker--messages">
                        { (!this.state.recording && this.state.startButton === 'Start') &&
                            <div>
                                <input 
                                    maxlength="40" 
                                    type="text" 
                                    defaultValue={ this.state.text } 
                                    onChange={ this.handleText } 
                                    onKeyPress={ this.handleKeyPress }
                                    onClick={ this.handleClickFocus }
                                />
                                <div class="GifMaker--messages--grid">
                                    <div>Add a custom message and press START</div>
                                    {this.state.isMobile &&
                                        <button onClick={ this.handleCameraToggle }>
                                            Camera <span>{ this.state.facingMode !== 'user' ? 'Back' : 'Front' }</span></button>
                                    }
                                </div>
                            </div>
                        }
                        { (!this.state.recording && this.state.startButton !== 'Start') &&
                            <p class="GifMaker--messages--flasher">Get ready!</p>   
                        }
                        { (this.state.recording && !this.state.render) &&
                            <Fragment>
                                <div class="GifMaker--messages--progress" style={{'width' : this.state.progress }}></div>
                                <p class="GifMaker--messages--flasher">Recording</p>    
                            </Fragment>
                        }
                        { this.state.render &&
                            <Fragment>
                                { !this.state.done && 
                                    <p class="GifMaker--messages--flasher">Creating your GIF</p>  
                                }
                                { this.state.done && 
                                    <div class="GifMaker--messages--grid">
                                        <div>Nice! Saving &mdash; { this.state.isMobile ? 'tap and hold for options' : 'right-click or drag to desktop' }</div>
                                        <button onClick={ this.handleRedo }>Again!</button>
                                    </div>
                                }
                            </Fragment>
                        }
                        { this.state.error &&
                            <p>uh oh... not working</p>    
                        }
                    </div>
                </section>
                <div class="GifMaker--thumbnails"></div>
            </main>
        );
    }
}

export default GifMaker;